import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import StorefrontLayout from "./components/StorefrontLayout";

/** @type {import('../types').StorefrontTenantModule} */
const vbsus = {
  key: "vbsus",
  label: "VBS USA",
  domains: ["vbspecialties.com", "www.vbspecialties.com"],
  codePath: "public-web/src/storefronts/vbsus",
  pages: {
    home: HomePage,
    catalog: CatalogPage,
    productDetail: ProductDetailPage,
    cart: CartPage,
    checkout: CheckoutPage,
    layout: StorefrontLayout,
  },
};

export default vbsus;
